import { displayGroup } from "../actions/session";
import { ComponentEx, connect, translate } from "./ComponentEx";
import { getSafe } from "../util/storeHelper";
import Icon from "./Icon";
import ToolbarIcon from "./ToolbarIcon";
import { Button } from "./TooltipControls";
import update from "immutability-helper";
import * as React from "react";
import { FormControl } from "react-bootstrap";
class InputButton extends ComponentEx {
    constructor(props) {
        super(props);
        this.state = {
            input: "",
        };
    }
    render() {
        const { t, buttonType, displayGroups, groupId, icon, iconGroup, id, tooltip, } = this.props;
        if (getSafe(displayGroups, [groupId], undefined) !== id) {
            return (React.createElement(ToolbarIcon, { id: id, text: tooltip, onClick: this.startInput, iconSet: iconGroup, icon: icon }));
        }
        else {
            const { input } = this.state;
            return (React.createElement("div", { className: "inline-form" },
                React.createElement("div", { style: { flexGrow: 1 } },
                    React.createElement(FormControl, { autoFocus: true, type: "text", value: input, onChange: this.updateInput, onKeyPress: this.handleKeypress })),
                React.createElement(Button, { id: "accept-input", tooltip: t("Confirm"), onClick: this.confirmInput },
                    React.createElement(Icon, { name: "input-confirm" })),
                React.createElement(Button, { id: "cancel-input", tooltip: t("Cancel"), onClick: this.closeInput },
                    React.createElement(Icon, { name: "input-cancel" }))));
        }
    }
    updateInput = (event) => {
        this.setState(update(this.state, {
            input: { $set: event.target.value },
        }));
    };
    startInput = () => {
        const { groupId, id, onSelectDisplayGroup } = this.props;
        onSelectDisplayGroup(groupId, id);
    };
    closeInput = () => {
        const { groupId, onSelectDisplayGroup } = this.props;
        this.setState(update(this.state, {
            input: { $set: "" },
        }));
        onSelectDisplayGroup(groupId, undefined);
    };
    handleKeypress = (evt) => {
        if (evt.which === 13) {
            evt.preventDefault();
            this.confirmInput();
        }
    };
    confirmInput = () => {
        this.props.onConfirmed(this.state.input);
        this.closeInput();
    };
}
function mapStateToProps(state) {
    return {
        displayGroups: state.session.base.displayGroups,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSelectDisplayGroup: (groupId, itemId) => dispatch(displayGroup(groupId, itemId)),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(InputButton));
